// 清晰分<30
export interface IndentityCode {
  bizCode: number;
  message: string;
}

export enum IndentityScoreEnum {
  sateBizCode = 0, // 成功, 无需重新上传身份证
  sateBizCodeTypeTecent = 1, // 腾讯ocr point<30 重新上传身份证
  sateBizCodeTypeHua = 2, // 华付 point<30  重新上传身份证
  stateCodeTypes = 3, // 未上传身份证
}
